import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

// Containers
const Deshboard = () => import('@/containers/Dashboard')

// Views
const Home = () => import('@/views/Home')
const Login = () => import('@/views/Login')
const CargaArchivos = () => import('@/views/CargaArchivos')
const SubirArchivo = () => import('@/views/SubirArchivo')
const AnexoReclamacion = () => import('@/views/AnexoReclamacion')
const VentaCartera = () => import('@/views/VentaCartera')
const Informes = () => import('@/views/Informes')
const VerInformes = () => import('@/views/VerInformes')
const Productos = () => import('@/views/Productos')
const Novedades = () => import('@/views/Novedades')
const EstadoProcesos = () => import('@/views/EstadoProcesos')
const Descargas = () => import('@/views/Descargas')
const Glosario = () => import('@/views/Glosario')
const CambioPass = () => import('@/views/CambioPassword')
const RenuevePassword = () => import('@/views/RenuevePassword')
const MisMensajes = () => import('@/views/MisMensajes')




Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
      path: '/',
      name: 'Inicio ',
      redirect: '/home',
      meta: {
        requiresAuth: true
      },
      component: Deshboard,
      children: [{
          path: '/home',
          name: 'Home',
          component: Home
        },
        {
          path: 'carga',
          redirect: 'carga',
          name: 'Cargue de archivos',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '',
              component: CargaArchivos,
            },
            {
              path: 'anexo-de-reclamacion',
              name: 'Anexo de reclamaciones',
              component: AnexoReclamacion
            },
            {
              path: 'venta-de-cartera',
              name: 'Venta de cartera',
              component: VentaCartera
            },
            {
              path: ':slug',
              name: 'Subir archivos',
              component: SubirArchivo
            }
          ]
        },
        {
          path: 'informes',
          redirect: 'informes',
          name: 'Informes',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '',
              component: Informes,
            },
            {
              path: ':id(\\d+)',
              name: 'Ver Informes',
              component: VerInformes
            },
            {
              path: 'resumen-cifras',
              name: 'Resumen de cifras',
              component: () => import('@/views/informes/ResumenCifras')
            },
            {
              path: 'base-garantizado',
              name: 'Base operaciones',
              component: () => import('@/views/informes/BaseGarantizados')
            },
            {
              path: 'consulta-general',
              name: 'Consulta general',
              component: () => import('@/views/informes/ConsultaGeneral')
            },
            {
              path: 'garantia-pagada',
              name: 'Operaciones pagadas',
              component: () => import('@/views/informes/GarantiaPagada')
            },
            {
              path: 'prefactura',
              name: 'Prefactura',
              component: () => import('@/views/informes/Prefactura')
            },
            {
              path: 'memorando',
              name: 'Memorando',
              component: () => import('@/views/informes/Memorando')
            },
            {
              path: 'devoluciones',
              name: 'Devoluciones',
              component: () => import('@/views/informes/Devoluciones')
            },
            {
              path: 'reintegros',
              name: 'Reintegros',
              component: () => import('@/views/informes/Reintegros')
            },
            {
              path: 'en-tramite-de-pago',
              name: 'En trámite de pago',
              component: () => import('@/views/informes/EnTramiteDePago')
            },
            {
              path: 'informe-novedades',
              name: 'Informe de novedades',
              component: () => import('@/views/informes/Novedades')
            },
            {
              path: 'subsanaciones',
              name: 'Subsanaciones',
              component: () => import('@/views/informes/Subsanaciones')
            },
            {
              path: 'rechazos',
              name: 'Rechazos',
              component: () => import('@/views/informes/Rechazos')
            },
            {
              path: 'estado-carteras-actualizadas',
              name: 'Estado de carteras actualizadas',
              component: () => import('@/views/informes/EstadoCarterasActualizadas')
            },
            {
              path: 'estado-reclamaciones',
              name: 'Estado de reclamaciones',
              component: () => import('@/views/informes/EstadoReclamaciones')
            },
            {
              path: 'venta-compra-cartera',
              name: 'Venta o compra de cartera',
              component: () => import('@/views/informes/VentaCompraCartera')
            },
            {
              path: 'resumen-utilizaciones',
              name: 'Resumen de utilizaciones',
              component: () => import('@/views/informes/ResumenUtilizaciones')
            }
          ]
        },
        {
          path: '/productos',
          name: 'Productos',
          component: Productos
        },
        {
          path: '/novedades',
          name: 'Novedades',
          component: Novedades
        },
        {
          path: '/estado-procesos',
          name: 'Estado de procesos',
          component: EstadoProcesos
        },
        {
          path: '/cambio-pass',
          name: 'Cambio de contraseña',
          component: CambioPass
        },
        {
          path: '/mensajes',
          name: 'Mis mensajes',
          component: MisMensajes
        },
        {
          path: '/utilidades',
          redirect: '/home',
          name: 'Utilidades',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '/descargas',
              name: 'Descargas',
              component: Descargas
            },
            {
              path: '/glosario',
              name: 'Glosario',
              component: Glosario
            }
          ]
        }
      ]
    }, {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/renueve-password',
      name: 'Renueve la contraseña',
      component: RenuevePassword,
    },
    //Si no encuentra la pagina redirecciona al login
    {
      path: '*',
      redirect: '/login'
    }
  ]

})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['user/isAuthenticated']) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

router.mode = 'html5'

export default router